import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";

// Component Imports
import Header from "./component/sections/Header/Header";
import Main from "./component/sections/Main/Main";
import AboutSection from "./component/sections/aboutUs/aboutSection";
import Mid from "./component/sections/Mid/Mid";
import Footer from "./component/sections/Footer/Footer";
import Subscribe from "./component/sections/Subscribe/Subscribe";
import Partner from "./component/sections/Partners/Partner";
import Serve from "./component/sections/Dataserve/Serve";
import Services from "./component/sections/Services/Services";
import Contact from "./component/Page/Contact/Contact";
import Service from "./component/Page/Services/Service";
import About from "./component/Page/AboutUs/About";
import Appoint from "./component/Appointment/Appoint";
import ScrollToTop from "./scroll";
import Activities from "./component/sections/Activities/Activities";
import Impact from "./component/sections/Impact/Impact";
import Value from "./component/sections/Value/Value";
import Tweets from "./component/sections/Tweets/Tweets";
import Reciept from "./component/Reciept/Reciept";
import Panel from "./component/Panel/Panel";
import Dashboard from "./component/Panel/Dashboard";
import ImageUpload from "./component/Upload/Upload";
import WhatsApp from "./component/WhatsApp/WhatsApp";
import Activity from "./component/Page/Activities/Activity";
import Gallery from "./component/Page/Gallery/Gallery";
import Leadership from "./component/Page/Leadership/Leadership";
import ServiceDetail from "./component/Page/ServiceDetail/ServiceDetail";

function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route
              path="/Contact"
              element={
                <>
                  <Header />
                  <Contact />
                  <Subscribe />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Services"
              element={
                <>
                  <Header />
                  <Service />
                  <Subscribe />
                  <Footer />
                </>
              }
            />
            {/* Individual service detail pages for SEO */}
            <Route
              path="/services/:slug"
              element={
                <>
                  <Header />
                  <ServiceDetail />
                  <Subscribe />
                  <Footer />
                </>
              }
            />
            <Route
              path="/AboutUs"
              element={
                <>
                  <Header />
                  <About />
                  <Subscribe />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Leadership"
              element={
                <>
                  <Header />
                  <Leadership />
                  <Subscribe />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Appointment"
              element={
                <>
                  <Header />
                  <Appoint />
                  <Subscribe />
                  <Footer />
                </>
              }
            />
            <Route path="/Reciept" element={<Reciept />} />
            <Route path="/Up" element={<ImageUpload />} />
            <Route
              path="/Admin"
              element={
                localStorage.getItem("logged") === "true" ? (
                  <Dashboard />
                ) : (
                  <Panel />
                )
              }
            />
            <Route
              path="/"
              element={
                <>
                  <Header />
                  <Main />
                  <Mid />
                  <AboutSection />
                  <Value />
                  <Services />
                  <Partner />
                  <Serve />
                  <Tweets />
                  <Impact />
                  <Activities />
                  <Subscribe />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Gallery"
              element={
                <>
                  <Header />
                  <Gallery />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Activity"
              element={
                <>
                  <Header />
                  <Activity />
                  <Footer />
                </>
              }
            />
          </Routes>
          <WhatsApp />
        </ScrollToTop>
      </Router>
    </HelmetProvider>
  );
}

export default App;
